import { EventDate } from '../Types/Event';
import { ajaxActions } from './AjaxActions';
import { ConstantS } from './ConstantS';
import { FileS } from './FileS';
import { MixpanelS } from './MixpanelS';
import { ToastS } from './ToastS';

const BASE_URL = `${process.env.REACT_APP_EVENT_SERVICE_URL}/eventDates`;

const create = async (eventId: string, payload: Partial<EventDate>): Promise<EventDate | null> => {
  const res = await ajaxActions.post(`${BASE_URL}?eventId=${eventId}`, payload);
  if (res.status === 201) {
    ToastS.success('event-date-created', 'Veranstaltungsdatum erstellt.');
    const { type } = payload;
    MixpanelS.track(
      type === 'REGULAR_DATE'
        ? ConstantS.TrackingEvents.RegularEventDateCreated
        : ConstantS.TrackingEvents.AppointmentEventDateCreated,
    );
    return res.json();
  }
  ToastS.generalError();
  return null;
};

const edit = async (
  id: number,
  patch: Partial<EventDate>,
  interceptViolation?: (httpResponse: Response) => void,
): Promise<EventDate | null> => {
  const res = await ajaxActions.patch(`${BASE_URL}/${id}`, patch);
  if (res.ok) {
    return res.json();
  }
  if (interceptViolation) {
    interceptViolation(res);
  } else {
    ToastS.generalError();
  }
  return null;
};

const remove = async (id: number, interceptViolation: (httpResponse: Response) => void): Promise<boolean> => {
  const res = await ajaxActions.del(`${BASE_URL}/${id}`);
  if (res.ok) {
    ToastS.info('event-date-deleted', 'Veranstaltungsdatum gelöscht.');
    return true;
  }
  interceptViolation(res);
  return false;
};

const assignPrimaryLocation = async (locationId: number, eventId: number) => {
  const res = await ajaxActions.patch(`${BASE_URL}/primary-location?locationId=${locationId}&eventId=${eventId}`, null);
  return res.ok;
};

const exportEventDatesCSV = async (filename: string, year?: number) => {
  const res = await ajaxActions.get(
    `${process.env.REACT_APP_DOCUMENT_SERVICE_URL}/csv/export/event-dates?year=${year}`,
  );
  if (res.ok) {
    MixpanelS.track(ConstantS.TrackingEvents.EventDatesExported);
    const blob = await res.blob();
    FileS.download(filename, blob);
  } else ToastS.generalError();
};

// eslint-disable-next-line import/prefer-default-export
export const EventDateS = {
  create,
  edit,
  remove,
  assignPrimaryLocation,
  exportEventDatesCSV,
};
